<template>
    <div class="w-full">
        <div class="rounded-lg min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <p class="text-gray-700 text-2xl mb-4 underline">N CNPS employeur : XXXXXX</p>

                <h2 class="text-3xl font-semibold text-gray-900 text-center my-16 underline">CERTIFICAT DE TRAVAIL</h2>

                <div class="mb-4">
                    <p class="mb-10 text-gray-700 text-2xl">
                        Nous, soussignés, International University of Grand-Bassam (IUGB), certifions que <span class="font-bold">{{ nom ?? "TITRE NOMS ET PRENOMS" }}</span>, numéro CNPS <span class="font-bold">{{ cnps ?? "XXXXXXXXXXXXX" }}</span>, a été employé par notre institution en qualité de <span class="font-bold">{{ fonction ?? "FONCTION" }}</span>, <span class="font-bold">{{ categorie ?? "CATEGORIE" }}</span>, <span class="font-bold">{{ startDate ?? "DATES" }}</span>.
                    </p>
                    <p class="mb-10 text-gray-700 text-2xl">
                        Il/Elle nous quitte ce jour libre de tout engagement.
                    </p>
                    <p class="mb-16 text-gray-700 text-2xl">
                        En foi de quoi, le présent certificat lui est délivré pour servir et valoir ce que de droit.
                    </p>
                </div>

                <div class="text-right text-2xl">
                    <p class="text-gray-700 mb-32">Fait à Grand-Bassam, le <span class="font-bold">DATE</span></p>
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>

                <div class="flex justify-end">
                        <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                            <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                            <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                        </div>
                </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "CertificatTravailValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            cnps: null,
            startDate: null,
            fonction: null,
            categorie: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.cnps= JSON.parse(data.data["data"]["content"]).cnps
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                    this.fonction= JSON.parse(data.data["data"]["content"]).fonction
                    this.categorie= JSON.parse(data.data["data"]["content"]).categorie
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>